import { flow } from 'mobx'
import { types } from 'mobx-state-tree'
import { authenticateModeOtp, getUserAuthModeRequest } from '../../network/authenticateOtp'
// import { authenticateModeOtp, getUserAuthModeRequest } from '../../network/authenticateOtp'
import { RootStore } from '../store'

const BcAppInfo = types
  .model('BcAppInfo', {
    userAccessToken: types.optional(types.maybeNull(types.string), ''),
    userIdentifier: types.optional(types.maybeNull(types.string), ''),
    authenticationToken: types.optional(types.maybeNull(types.string), ''),
  })
  .actions((self) => ({
    updateBCAppSessionData: function updateBcAppInfo(
      userAccessToken: string,
      userIdentifier: string,
      authenticationToken: string,
    ) {
      self.userAccessToken = userAccessToken
      self.userIdentifier = userIdentifier
      self.authenticationToken = authenticationToken
      console.log(authenticationToken, self.authenticationToken, 'htag userIdentifier', userAccessToken, userIdentifier)
      console.log(authenticationToken, self.authenticationToken, 'htag userIdentifier', userAccessToken, userIdentifier)
    },
    userAuthenticateAsync: flow(function* userAuthenticateAsync() {
      try {
        const agent = RootStore.agent
        const authParams = {
          type: agent.type,
          encToken: agent.encToken,
          encKey: agent.encKey,
          parentOrigin: agent.parentOrigin,
          transactionType: agent.transactionType,
        }
        const req = getUserAuthModeRequest(self.authenticationToken, authParams)
        const res = yield authenticateModeOtp(RootStore?.agent?.session, req, authParams)
        console.log(authParams, 'res =', res)
        return res
      } catch (err) {
        if (err?.code === '33848') {
          RootStore.message.showErrDialog('Parent app session expired. Please re-login', 'CLOSE_WEBVIEW')
        }
        console.log('err ', err)
        throw err
      }
    }),
  }))

const BcAppInfoData = BcAppInfo.create({ userAccessToken: '', userIdentifier: '' })

export { BcAppInfo, BcAppInfoData }
